import React from 'react';

import Transcript from './Transcript';
import moment from 'moment';

const imageUrl = 'https://i.ytimg.com/an_webp/Q5POuMHxW-0/mqdefault_6s.webp?du=3000&sqp=CIeA9MsF&rs=AOn4CLDBxEMvQj8W1Yu38CmlyibIQHfKsg';

const makeImageURL = (ytid) =>
  `https://img.youtube.com/vi/${ytid}/0.jpg`;

const VideoInfo = ({
  ytid,
  cues,
  relevantCues,
  title = 'Introduction to Docker',
  description = 'dotCloud founder and CTO Solomon Hykes recently stopped by Twitter HQ to show us Docker, an open source project designed …',
  publishedAt = '3 years ago',
  transcript = 'sorry',
  views = '696,969',
  source = 'Twitter University',
  keywords,
  onVideoClick,
}) => {
  return (
    <div className='videoInfo'>
      <img src={makeImageURL(ytid)} />
      <div className="videoMeta">
        <a onClick={() => {
          onVideoClick(ytid, 0);
        }}><h3>{title}</h3></a>
        <p className="byline">{publishedAt} &middot; {views} views</p>
        <p>{description}</p>
        <Transcript keywords={keywords} cues={cues} relevantCues={relevantCues} videoId={ytid} onVideoClick={onVideoClick} />
      </div>
    </div>
  );
};

const Results = ({ keywords, videos, onVideoClick }) => {
  if (!videos) {
    return (
      <div className="results">
      </div>
    );
  }
  return (
    <div className="results">
      {videos.map(video => {
        return (
          <VideoInfo
            title={video._source.info.title || 'Youtube Video'}
            description={video._source.info.description || 'Video'}
            views={video._source.info.statistics.viewCount || 0}
            keywords={keywords || 0}
            publishedAt={moment(video._source.info.publishedAt).fromNow() || 0}
            cues={video._source.cues || ""}
            relevantCues = {video._source.relevantCues || ""}
            key={video._id || ""}
            onVideoClick={onVideoClick || ""}
            ytid={video._source.video_id || 0} />
        );
      })}
    </div>
  );
};

export default Results;



// WEBPACK FOOTER //
// ./src/SearchPage/Results.js